import React, { useState } from 'react';
import { Form, Input, Button, Col } from 'antd';
import './MembershipLoginForm.less';
import { useSelector } from 'react-redux';
import { RootState } from '../../../store/store';
import { useMembershipAuth } from '../../../hooks/useMembershipAuth';
import SpinLoader from '@skygroup/shared/components/spin-loader/SpinLoader';
import ModelApiMessage, {
  ApiStatus,
  ApiStatusMessage,
} from '@skygroup/shared/components/crud-helpers/ModelApiMessage';

interface LoginFormProps {
  setIsLoginSuccess: (success: boolean) => void;
  setSessionId: (sessionId: string) => void;
}
const columnSize = {
  xs: 20,
  md: 35,
};
const MembershipLoginForm: React.FC<LoginFormProps> = ({
  setIsLoginSuccess,
  setSessionId,
}) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const { translations: t , config} = useSelector(
    (data: RootState) => data.config
  );
  const { membershipLogin } = useMembershipAuth();

  const [apiStatusMessage, setApiStatusMessage] = useState(
    {} as ApiStatusMessage
  );

  const handleSubmit = async (values: { id: string; phone: string }) => {
    setLoading(true);
    try {
      const sessionId = await membershipLogin(values.id, values.phone, config.siteConfig?.membership?.auth_type || 'org_istadrut');
      setSessionId(sessionId);
      setIsLoginSuccess(true);
    } catch (error: any) {
      return setApiStatusMessage({
        status: ApiStatus.error,
        data: { message:  error.message ?? t.auth.loginError },
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <SpinLoader isLoading={loading} size="large" onTop={true}>
      <Form
        form={form}
        onFinish={handleSubmit}
        layout="vertical"
        className="membership-login-form"
      >
        <Form.Item
          label={t.auth.id}
          name="id"
          rules={[
            { required: true, message: t.auth.idPlaceholderError },
            { pattern: /^[0-9]{9}$/, message: t.auth.idDigits },
          ]}
        >
          <Input placeholder={t.auth.idPlaceholder} />
        </Form.Item>
        <Form.Item
          label={t.auth.phone}
          name="phone"
          rules={[
            { required: true, message: t.auth.phonePlaceholderError },
            { pattern: /^[0-9]{10}$/, message: t.auth.phoneDigits },
          ]}
        >
          <Input placeholder={t.auth.phonePlaceholder} />
        </Form.Item>
        <Form.Item>
          <Button
            className="btn-style-5"
            type="primary"
            htmlType="submit"
            block
          >
            {t.auth.send}
          </Button>
        </Form.Item>
        <Col {...columnSize} offset={1}>
          <ModelApiMessage apiStatusMessage={apiStatusMessage} t={t.auth.crud} />
        </Col>
      </Form>
    </SpinLoader>
  );
};

export default MembershipLoginForm;
